(function() {
    angular
        .module('app')
        .directive('pageList',pageList);

    function pageList(){

        return {
            restrict: 'E',
            templateUrl :'app/directives/pageList/pageList.html',
            scope: {
                pageNav: '=',
                currentSearch: '=',
                setNewPage: '=',
                setPage: '=',
                resultsPageButtonText: '='
            },
            link: function (scope, el, attrs) {
                const getText = (param,text) => {
                    return typeof(param) !== "undefined" ? param : text
                }

                window._pages = {pages:scope.pages,currentSearch:scope.currentSearch,setPage:scope.setPage}
                scope.previousButtonText = getText(scope.resultsPageButtonText.previous,"Previous");
                scope.nextButtonText = getText(scope.resultsPageButtonText.next,"Next");

            }
        }
    }
})();